<template>
  <q-dialog persistent v-model="showDialog">
    <q-card style="width: 90vw">
      <q-bar class="bg-red text-white">
        <q-icon name="warning" size="sm" color="orange"></q-icon>
        <div class="text-h6">Delete</div>
        <q-space />
        <q-btn
          class="q-pl-xs q-ml-md"
          flat
          v-close-popup
          @click="showDialog = false"
          dense
          icon="close"
        />
      </q-bar>
      <DeleteMessageTitle
        :deleteTitle="delTitle || deleteTitle"
        :deleteMessage="delMessage || deleteMessage"
      />
      <div class="q-pa-sm">
        <div class="row justify-end">
          <q-btn
            class="q-pa-xs"
            dense
            color="red"
            no-caps
            :label="btnName"
            icon-right="delete"
            style="min-width: 120px"
            @click="yesOrNo('y')"
          >
          </q-btn>
        </div>
      </div>
    </q-card>
  </q-dialog>
</template>
<script setup>
import { ref } from "vue";
import DeleteMessageTitle from "./settings/DeleteAccount/DeleteMessageTitle/DeleteMessageTitle.vue";
const showDialog = ref(false);
const delTitle = ref("");
const delMessage = ref("");

let resolveDelete;
let rejectDelete;
const props = defineProps({
  deleteTitle: {
    type: String,
    default: () => "Delete",
  },
  deleteMessage: {
    type: String,
    default: () => "Are you sure you want to delete?",
  },
  btnName: {
    type: String,
    default: () => "Delete",
  },
});
const openDialog = (data) => {
  showDialog.value = true;
  if (data) {
    delTitle.value = data.title;
    delMessage.value = data.message;
  }
  return new Promise((resolve, reject) => {
    resolveDelete = resolve;
    rejectDelete = reject;
  });
};

const yesOrNo = (answer) => {
  showDialog.value = false;
  if (answer == "y") {
    resolveDelete(answer);
  } else {
    rejectDelete(answer);
  }
};

defineExpose({ openDialog });
</script>
